var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"MainLanding"},[_c('app-navbar'),_vm._t("default"),_c('app-footer'),_c('img',{staticClass:"new-wa-btn",attrs:{"src":require("@/assets/Images/wa-not-hover.png"),"alt":"WA","id":"btn-wa-footer"},on:{"click":_vm.actionClickWA,"mouseover":_vm.waHover,"mouseout":_vm.waNotHover}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }